import { useEffect, useState } from 'react';
import { getGlobalVariable,
  setGlobalVariable,
  subscribeToGlobalVariable } from '../utils/global-variables/global-variables';
import type { GlobalVariableKey } from '../utils/global-variables/global-variables-types/global-variable-key';
import type { GlobalVariablesMap } from '../utils/global-variables/global-variables-types/global-variables-map';

export const useGlobalVariable = <Key extends GlobalVariableKey>(globalVariableKey: Key) => {
  const [value, setValue] = useState(getGlobalVariable(globalVariableKey));

  useEffect(() => {
    const unsubscribe = subscribeToGlobalVariable((_key, newValue) => {
      setValue(newValue);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const handleSetGlobalVariable = (newValue: GlobalVariablesMap[Key]) => {
    setGlobalVariable(globalVariableKey, newValue);
  };

  return [value, handleSetGlobalVariable] as const;
};